import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';

import TranslationHelper from '../common/TranslationHelper';

import '../css/success.css';

export default class VerifyNeeded extends React.Component {
	static contextTypes = {
		router: PropTypes.object
	}

	constructor(props, context) {
		super(props, context);
		this.state = {};
	}

	render() {
		return (
			<Container fluid id="background-image">
				<div className="inner-container">
					<div className="transparent-box" style={{ maxWidth: '80%' }}>
						<h3 className="success">{TranslationHelper.getValue('customer_account.unauthorized.verify')}</h3>
						<p className="success m-0" style={{ fontSize: '18px' }}>{TranslationHelper.getValue('customer_account.unauthorized.verificationNeeded')}</p>
					</div>
				</div>
			</Container>
		);
	}
}
